import { Arrow, Content, Portal, Provider, Root, Trigger } from '@radix-ui/react-tooltip'
import type { ReactElement, ReactNode } from 'react'
import cc from 'classcat'

import type { PopoverAlign, PopoverSide } from '../Popover/types'

const DEFAULT_DELAY_DURATION = 50

interface TooltipProps {
  readonly trigger?: ReactNode | string
  readonly content: ReactNode
  readonly side?: PopoverSide
  readonly align?: PopoverAlign
  readonly sideOffset?: number
  readonly open?: boolean
  readonly usePortal?: boolean
  readonly disabled?: boolean
  readonly hideIcon?: boolean
}

export function Tooltip({
  trigger,
  content,
  side,
  align,
  sideOffset,
  open,
  usePortal = false,
  disabled,
  hideIcon,
}: TooltipProps): ReactElement {
  const ContentWrapper = usePortal ? Portal : 'div'

  return (
    <Provider>
      <Root disableHoverableContent delayDuration={DEFAULT_DELAY_DURATION} open={disabled ? false : open}>
        <Trigger
          className={cc(['tooltip-trigger', { 'ep-info-bubble': !hideIcon }])}
          data-testid="tooltip-trigger"
          asChild
        >
          <span>{trigger}</span>
        </Trigger>
        <ContentWrapper>
          <Content
            className={`tooltip-content`}
            side={side}
            align={align}
            sideOffset={sideOffset}
            collisionPadding={10}
            avoidCollisions={true}
            data-testid="tooltip-content"
          >
            {content}
            <Arrow className={`tooltip-arrow`} />
          </Content>
        </ContentWrapper>
      </Root>
    </Provider>
  )
}
